import wos from 'apis/wos';

import type { Session } from 'domains/session';

export const get = async () => {
  const { data } = await wos.get<Session>('/current_user.json');
  return data;
};
